import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
var ShiftsService = /** @class */ (function () {
    function ShiftsService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    ShiftsService.prototype.getAllShifts = function () {
        var url = environment.apiBase + 'shifts/admin';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    ShiftsService.prototype.getShift = function (shiftId) {
        var url = environment.apiBase + ("shifts/" + shiftId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    ShiftsService.prototype.rotateShift = function (shiftId) {
        var url = environment.apiBase + ("rotate/" + shiftId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.put(url, {}, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    return ShiftsService;
}());
export { ShiftsService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/shifts.service.ts.pre-build-optimizer.js